/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { NavigationGuardNext, Route } from 'vue-router';
import { mantecaWithdrawalsHistoryPermissions } from './permissions/index';
import store from '@/store';
import authType from '@/store/types/auth';

const MantecaWithdrawals = () =>
  import(
    /* webpackChunkName: "manteca_withdrawals" */
    '@/views/MantecaWithdrawals/index.vue'
  );

const mantecaWithdrawalsPages = {
  path: '/',
  component: DashboardLayout,
  name: 'Withdrawals',
  children: [
    {
      path: '/withdrawals/manteca',
      name: 'mantecaWithdrawals',
      component: MantecaWithdrawals,
      beforeEnter(
        _to: Route,
        _from: Route,
        next: NavigationGuardNext<Vue>
      ): void {
        const permissions: string[] =
          store.getters[`authModule/${authType.getters.PERMISSIONS}`] || [];
        const hasAccess = mantecaWithdrawalsHistoryPermissions.every((permission) =>
          permissions.includes(permission)
        );
        if (!hasAccess) {
          next('/403');
          return;
        }
        next();
      },
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default mantecaWithdrawalsPages;
